"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _ItemBase = _interopRequireDefault(require("./ItemBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react-native-a11y/has-valid-accessibility-role */

const OrderedListBase = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    accessibilityRole: "list",
    ref: ref,
    style: staticStyles.container,
    ...rest,
    children: children
  });
});
OrderedListBase.propTypes = {
  /**
   * A list of ordered items wrapped in `OrderedListBase.Item`.
   */
  children: _propTypes.default.node.isRequired
};
OrderedListBase.displayName = 'OrderedList';
OrderedListBase.Item = _ItemBase.default;
var _default = exports.default = OrderedListBase;
const staticStyles = _StyleSheet.default.create({
  container: {
    flexDirection: 'column',
    margin: 0,
    padding: 0
  }
});